import type { ProductType } from '@atlassian/loom-utils';
import type { UniversalCreateSourceProduct } from '@atlassian/universal-create-common';

export function convertSourceProductToProductType(
	product: UniversalCreateSourceProduct,
	subProduct?: string,
): ProductType {
	switch (product) {
		case 'townsquare': {
			if (subProduct === 'goal') {
				return 'GOAL';
			}
			if (subProduct === 'teams') {
				return 'TEAMS';
			}
			if (subProduct === 'home') {
				return 'HOME';
			}
			return 'TOWNSQUARE';
		}
		case 'confluence':
			return 'CONFLUENCE';
		case 'rovoExtension':
			return 'ROVO_EXTENSION';
		default:
			return 'UNKNOWN';
	}
}
